/** Quick add host: the dialog shell loads with the app; the form loads on first open. */
import { Suspense, lazy } from 'react';
import { useUI } from '@/state/ui';
import { Dialog } from '@/components/ui/overlay';

const QuickAdd = lazy(() => import('./QuickAdd'));

export function QuickAddHost() {
  const prefill = useUI((s) => s.quickAdd);
  const close = useUI((s) => s.closeQuickAdd);
  return (
    <Dialog open={!!prefill} onOpenChange={(o) => !o && close()}>
      <Suspense fallback={null}>{prefill && <QuickAdd key={JSON.stringify(prefill)} />}</Suspense>
    </Dialog>
  );
}
